import React from 'react'

const GetQuote = (props) => {
  const { btnLabel } = props
  return(
    <div className="subscribe-form mx-auto p-2">
    <form action="https://cl.s11.exct.net/subscribe.aspx?lid=610" name="subscribeForm" method="post" onSubmit="return checkForm();" > 
      <input type="hidden" name="thx" value="https://www.omnidya.com" /> {/* Thank You Page Details here */}
      <input type="hidden" name="err" value="https://www.omnidya.com" /> {/* Error Page Details here */}
      <input type="hidden" name="MID" value="514010013" /> {/* Do not change this */}
      <div class="row">
        <div class="col-lg col-sm col-12">
          <input type="text" name="Email Address" class="form-control border-0" placeholder="example@email.com" />
        </div>
        <div class="col-lg-auto col-sm-auto col-12 mt-xs-2">
          <button type="submit" name="submit" class="btn btn-block btn-gradient">
            {btnLabel}
          </button>
        </div>
      </div>
    </form>
    </div>
    // <div className="row justify-content-center text-center">
    //   <div className="col col-lg-4">
    //   </div>
    // </div>
  )
}

export default GetQuote